import type { FunctionComponent } from 'react';
import { ReviewCarouselItem } from '../interface';
import * as styles from './ReviewItem.module.scss';

const cardReviewMessage = {
  VerifiedMember: 'Verified Member',
  dataTestId: 'card-review-id',
};

export const ReviewItem: FunctionComponent<ReviewCarouselItem> = ({
  title,
  description,
  imageUrl,
  onClick,
}) => {
  return (
    <div data-testid={cardReviewMessage.dataTestId} className={styles.item}>
      {onClick && <button className={styles.clickableArea} onClick={onClick} aria-hidden="true" />}
      <div className={styles.thumbnailContainer}>
        <img src={imageUrl} alt={title} />
      </div>
      <span className={styles.content}>
        <p className={styles.title}>{title}</p>
        <p className={styles.reviewText}>{description}</p>
        <span className={styles.verifiedTag}>{cardReviewMessage.VerifiedMember}</span>
      </span>
    </div>
  );
};

export { cardReviewMessage };
